export const getInitialFilteredTags = (setTagOptions, filterSelector) => {
    setTagOptions("Attributes", filterSelector.interestIssues);
    setTagOptions("responsibles", filterSelector.coReponsibleDivisions);
    setTagOptions("country", filterSelector.countryId);
    setTagOptions("division", filterSelector.divisionId.filter(division => division.selectedByUser));
    setTagOptions("execution", filterSelector.executionFilter);
    setTagOptions("taxonomy", filterSelector.taxonomyFilter);
    setTagOptions("participants", filterSelector.participantDivisions)
    setTagOptions('regions', filterSelector.regionId);
    setTagOptions('sector', filterSelector.sectors);
    setTagOptions("teamLeader", filterSelector.teamLeaders);
    setTagOptions("pmr", filterSelector.pmrId.filter(pmr => pmr.selected));
    setTagOptions("timeWithoutDisbursement", setTagsRange(filterSelector, 'timeWithoutDisbursementFrom', 'timeWithoutDisbursementTo'));
    setTagOptions("ageProject", setTagsRange(filterSelector, 'ageProjectFrom', 'ageProjectTo'));
    setTagOptions("disbursementProjection", setTagsRange(filterSelector, 'disbursementProjectionFrom', 'disbursementProjectionTo'));
    setTagOptions("excludeRegionals", setTagExcludeRegionals(filterSelector));
}


export const setTagsRange = (
    filterSelector,
    fromKey,
    toKey,
    fromLabel = 'From',
    toLabel = 'To'
) => {
    let filterApplied: any = [];
    const fromValue = filterSelector[fromKey];
    const toValue = filterSelector[toKey];
    if (fromValue) {
        filterApplied.push({
            id: 1,
            label: `${fromLabel} ${fromValue}`,
            value: fromValue,
        });
    }
    if (toValue) {
        filterApplied.push({
            id: 2,
            label: `${toLabel} ${toValue}`,
            value: toValue,
        });
    }
    return filterApplied;
};

export const setTagExcludeRegionals = (filterSelector) => {
    if (!filterSelector.excludeRegionals) return [];

    return [{
        id: 0,
        label: 'Exclude Regional',
        value: filterSelector.excludeRegionals,
    }];
}